Application.Forms.CheckBoxShow = {
    ui: {
        dataWrap: 'wrap-id',
        clTrigger: 'js-show-input',
    },
    ready: function () {

        var self = this;

        function fnShowInput(el,effect){
            var $this = el,
                $effect = effect,
                $wrapData = self.ui.dataWrap,
                $wrapId = $this.data($wrapData),
                $wrap = $('#'+$wrapId);
            if($wrap.length){
                var $checked = false;
                $('[data-'+$wrapData+'='+$wrapId+']').each(function(){
                    if($(this).is(':checked')){
                        $checked = true;
                    }
                });
                if($checked==true){
                    if($effect=='slide'){
                        $wrap.slideDown();
                    }else{
                        $wrap.show();
                    }
                }else{
                    if($effect=='slide'){
                        $wrap.slideUp();
                    }else{
                        $wrap.hide();
                    }
                }
            }
        }
        $('.'+self.ui.clTrigger).each(function(){
            fnShowInput($(this));
        });

        $('.'+self.ui.clTrigger).on('click',function(){
            fnShowInput($(this),'slide');
        });
    }
};